/** 모바일 Drawer가 pathname 이동과 query 기반 하위 메뉴 이동을 모두 감지할 키를 만든다. */
export const getMobileNavLocationKey = (location) =>
  `${location?.pathname || ""}${location?.search || ""}`;
